var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("plain-text-control", {
        attrs: {
          title: _vm.title,
          required: _vm.isDivided,
          instructionKey: _vm.instructionsKey
        }
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: { "aria-label": _vm.$t(_vm.title) }
        },
        [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                { staticClass: "w-20", attrs: { id: _vm.title + "_jobTitle" } },
                [
                  _c(
                    "span",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.SalaryItems.JobTitle"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            _vm.pathKey +
                              ".PersonnelExpenses.SalaryItems.JobTitle_Instructions"
                          )
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-20",
                  attrs: { id: _vm.title + "_description" }
                },
                [
                  _c(
                    "span",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.SalaryItems.Description"
                            )
                          ) +
                          "\n            "
                      ),
                      !_vm.isDivided
                        ? _c("tooltip-icon", {
                            attrs: {
                              content: _vm.$t(
                                _vm.pathKey +
                                  ".PersonnelExpenses.SalaryItems.Description_Instructions"
                              )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-15 right",
                  attrs: { id: _vm.title + "_grossSalary" }
                },
                [
                  _c(
                    "span",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.SalaryItems.GrossSalary"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            _vm.pathKey +
                              ".PersonnelExpenses.SalaryItems.GrossSalary_Instructions"
                          )
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-15 right",
                  attrs: { id: _vm.title + "_hours" }
                },
                [
                  _c(
                    "span",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.SalaryItems.WorkingHours"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            _vm.pathKey +
                              ".PersonnelExpenses.SalaryItems.WorkingHours_Instructions"
                          )
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-15 right",
                  attrs: { id: _vm.title + "_hoursPercent" }
                },
                [
                  _c(
                    "span",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.SalaryItems.WorkingHoursPercent"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            _vm.pathKey +
                              ".PersonnelExpenses.SalaryItems.WorkingHoursPercent_Instructions"
                          )
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.isDivided
                ? _c(
                    "th",
                    {
                      staticClass: "w-10",
                      attrs: { id: _vm.title + "_divided" }
                    },
                    [
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  _vm.pathKey +
                                    ".PersonnelExpenses.SalaryItems.IsDivided"
                                )
                              ) +
                              "\n            "
                          ),
                          _c("tooltip-icon", {
                            attrs: {
                              content: _vm.$t(
                                _vm.pathKey +
                                  ".PersonnelExpenses.SalaryItems.IsDivided_Instructions"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _c(
                    "th",
                    {
                      staticClass: "w-10",
                      attrs: { id: _vm.title + "_steaTarget" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.pathKey +
                                ".PersonnelExpenses.DividedSalaryItems.IsSteaAidTarget"
                            )
                          )
                        )
                      ])
                    ]
                  ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-5 centered",
                  attrs: { id: _vm.title + "_actions" }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item, index) {
              return _c("tr", { key: index, staticClass: "paddingless" }, [
                _c(
                  "td",
                  { staticClass: "w-20 input-cell" },
                  [
                    _c("text-area-control", {
                      class: "salary-row-" + (index + 1),
                      attrs: {
                        id: _vm.getId("jobtitle", index),
                        maxLength: 30,
                        required: _vm.isRequired(item),
                        rows: 1,
                        placeholderKey: "Placeholder.TextArea",
                        labelledBy: _vm.title + "_jobTitle"
                      },
                      model: {
                        value: item.title,
                        callback: function($$v) {
                          _vm.$set(item, "title", $$v)
                        },
                        expression: "item.title"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-20 input-cell" },
                  [
                    _c("text-area-control", {
                      attrs: {
                        id: _vm.getId("description", index),
                        maxLength: 200,
                        required: _vm.isRequired(item),
                        rows: 1,
                        placeholderKey: "Placeholder.TextArea",
                        labelledBy: _vm.title + "_description",
                        showTooltip: true
                      },
                      model: {
                        value: item.description,
                        callback: function($$v) {
                          _vm.$set(item, "description", $$v)
                        },
                        expression: "item.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        required: _vm.isRequired(item),
                        placeholderKey: _vm.numberInputPlaceholderKey,
                        labelledBy: _vm.title + "_grossSalary"
                      },
                      model: {
                        value: item.grossSalary,
                        callback: function($$v) {
                          _vm.$set(item, "grossSalary", $$v)
                        },
                        expression: "item.grossSalary"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        required: _vm.isRequired(item),
                        minValue: 1,
                        maxValue: _vm.maxWorkingHours,
                        placeholderKey: _vm.numberInputPlaceholderKey,
                        labelledBy: _vm.title + "_hours"
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.calculatePersonYears(item)
                        }
                      },
                      model: {
                        value: item.workingHours,
                        callback: function($$v) {
                          _vm.$set(item, "workingHours", $$v)
                        },
                        expression: "item.workingHours"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "w-15 input-cell" },
                  [
                    _c("numeric-input-control", {
                      attrs: {
                        required: _vm.isRequired(item),
                        maxValue: 100,
                        placeholderKey: _vm.numberInputPlaceholderKey,
                        labelledBy: _vm.title + "_hoursPercent"
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.calculatePersonYears(item)
                        }
                      },
                      model: {
                        value: item.workingHoursPercent,
                        callback: function($$v) {
                          _vm.$set(item, "workingHoursPercent", $$v)
                        },
                        expression: "item.workingHoursPercent"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isDivided
                  ? _c(
                      "td",
                      {
                        class: [
                          "w-10 normal",
                          _vm.isReadOnly ? "disabled-background" : ""
                        ]
                      },
                      [
                        _c("check-box-control", {
                          attrs: {
                            tooltipKey:
                              _vm.pathKey +
                              ".PersonnelExpenses.SalaryItems.IsDivided_Instructions",
                            labelledBy: _vm.title + "_divided"
                          },
                          model: {
                            value: item.isDivided,
                            callback: function($$v) {
                              _vm.$set(item, "isDivided", $$v)
                            },
                            expression: "item.isDivided"
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "td",
                      {
                        class: [
                          "w-10",
                          _vm.isReadOnly ? "disabled-background" : ""
                        ]
                      },
                      [
                        _c("check-box-control", {
                          attrs: { labelledBy: _vm.title + "_steaTarget" },
                          model: {
                            value: item.isSteaAidTarget,
                            callback: function($$v) {
                              _vm.$set(item, "isSteaAidTarget", $$v)
                            },
                            expression: "item.isSteaAidTarget"
                          }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: [
                      "w-5 centered",
                      _vm.isReadOnly ? "disabled-background" : ""
                    ]
                  },
                  [
                    _c("span", [
                      _vm.showDeleteBtn && !_vm.isReadOnly
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: { content: _vm.$t("Btn_DeleteRow") },
                                  expression:
                                    "{ content: $t('Btn_DeleteRow') }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass: "btn btn-link btn-contrast",
                              attrs: {
                                type: "button",
                                "aria-label":
                                  _vm.$t("Btn_DeleteRow") +
                                  (index + 2) +
                                  " -. " +
                                  _vm.$t("Accessibility.ConfirmDeleteRow")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRow(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-trash-alt fa-lg centered"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ])
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("div", { staticClass: "mt-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.addRow()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t(_vm.buttonTitle)))]
            )
          ])
        : _c("div", { staticClass: "mt-5" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }